// extracted by mini-css-extract-plugin
export var borderBlink = "InitialStep-module--borderBlink--c25dd";
export var fadeInAnimation = "InitialStep-module--fadeInAnimation--e6b87";
export var inputsWrapper = "InitialStep-module--inputsWrapper--58410";
export var tag = "InitialStep-module--tag--9ce63";
export var title = "InitialStep-module--title--08d5e";
export var validate = "InitialStep-module--validate--d7b16";